import { Layout } from './constant'
import { useLayout } from './useLayout'

export function useIsNewLayout() {
  const { layout } = useLayout()

  return layout === Layout.NEW
}
